import React from 'react';
import { Card, Button } from 'react-bootstrap';
import StageManager from '../../services/stageManager';
import { getTreeFromDb } from '../../services/publishData';
import { withRouter } from "react-router";
import UserForm from '../adminCenter/UserForm';
import { changeStage, updateTenantInfo } from '../../services/customer';
import { TenantForm } from '../adminCenter/TenantForm';
import { addNotification } from '../../action/notificationAction';
import Loader from 'react-loader-spinner';

/**Part of the AdminController this is the individual company view
 * For viewing the tree, Adding new users, updating Client credentials 
 * and updating the stage
 */
class AdminControllerEntity extends React.Component {
    constructor(props) {
        super(props);
        this.stageManager = new StageManager();
        this.state = {
            user: false,
            stageLoading: false,
            addCreds: false,
            updateTentantDetails: {
                tenant: "",
                sharepointURL: "",
                username: "",
                clientId: ""
            }
        };
    }
    componentDidMount() {
        // getPublishedTrees();
    }
    componentWillMount() {
        this.setState({
            company: this.props.company,
            stages: this.stageManager.getStageByIndex(this.props.company.stage)
        });
    }

    componentWillUnmount() {

    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.company !== this.state.company) {
            this.setState({
                company: nextProps.company,
                stages: this.stageManager.getStageByIndex(nextProps.company.stage)
            });
        }
    }
    stageLoader = () => this.setState((prevState) => ({ stageLoading: !prevState.stageLoading }));
    /**Part of the updating client credentials state */
    resetTenantState = () => this.setState({
        updateTentantDetails: {
            tenant: "",
            sharepointURL: "",
            username: "",
            clientId: ""
        }
    });
    /**Retrieves the tree, then waits a second and redirects to the new tree (Bad)
     */
    viewTree = () => {
        getTreeFromDb(this.state.company.id);
        setTimeout(this.props.history.push("/tree"), 1250);
    };
    /**On click handler to hide adding creds but to show adding users */
    userClick = () => this.setState((prevState) => ({ user: !prevState.user, addCreds: false }));
    /**On click handler to hide adding users but to show adding credential */
    updateCredsClient = () => this.setState((prevState) => ({ addCreds: !prevState.addCreds, user: false }));

    addTeantDetails = (objectName, objectValue) => this.setState((prevState) =>
        ({ updateTentantDetails: { ...prevState.updateTentantDetails, [objectName]: objectValue } }));
    /**On click handler for Stage handler */
    onClickStaging = (type) => {
        this.stageLoader();
        changeStage(type, this.state.company.id)
            .then((res) => {
                this.stageLoader();
                this.props.updateStage(res.stage, this.state.company.id);
            }).catch(() => this.stageLoader());
    };
    /**Part of the updating client credentials,
     *  makes sure the creds arent empty */
    onClickSubmitCreds = async () => {
        const { updateTentantDetails } = this.state;
        if (updateTentantDetails === undefined) {
            return addNotification({ status: "fail", message: `The tenant info cannot be undefined` });
        }
        const errMessage = [];
        if (updateTentantDetails.tenant.length === 0) {
            errMessage.push("Tenant cannot be empty");
        }
        if (updateTentantDetails.sharepointURL.length < 5) {
            errMessage.push("Sharepoint URL is not long enough");
        }
        if (updateTentantDetails.username.length === 0) {
            errMessage.push("Usename cannot be empty");
        }
        if (updateTentantDetails.clientId.length === 0) {
            errMessage.push("Client ID cannot be empty");
        }
        if (errMessage.length > 0) {
            return addNotification({ status: "fail", message: `Error updating client creds, ${errMessage.join(" , ")}` });
        }
        this.stageLoader();
        try {
            await updateTenantInfo(updateTentantDetails, this.state.company.id);
            this.resetTenantState();
            addNotification({ status: "success", message: "Tenant info updated" });
        } catch (error) {
            console.log(error);
            addNotification({ staus: "fail", message: error.message });
        } finally {
            this.stageLoader();
            return;
        }
    };
    render() {
        const { company, addCreds, stages, user, stageLoading, updateTentantDetails } = this.state;
        return (
            <Card>
                <Card.Header><span className="float-left">At Stage: {stages.name}</span><b>{company.company}</b> <span className="float-right"> Created By: {company.createdBy}</span></Card.Header>
                <Card.Body>
                    {/* <Card.Text className="float-left">
                        
                    </Card.Text> */}
                    {/* <div className="float-right"> */}
                    <Button onClick={this.viewTree} variant="success">View tree</Button> &nbsp;
                    <Button onClick={this.userClick} variant="success">Add new user</Button> &nbsp;
                    <Button onClick={() => this.props.onAddTemplate(company.id)} variant="success">Add Template</Button> &nbsp;
                    <Button onClick={()=> this.props.onAddTheme(company.id)} variant="success">Add Theme</Button>&nbsp;
                    <Button onClick={this.updateCredsClient} variant="success">Update Client Credentials</Button> &nbsp;


                    {/* </div> */}
                    <Card className="float-right" style={{ width: "250px", height: "100px", margin: "5px" ,}}>
                        <Card.Title>
                            Staging
                    </Card.Title>
                        <Card.Body>
                            <Button variant="outline-success" disabled={stageLoading} onClick={() => this.onClickStaging("add")}>+</Button>&nbsp;
                            <Button variant="outline-danger" disabled={stageLoading} onClick={() => this.onClickStaging("remove")}>-</Button> &nbsp;
                        </Card.Body>

                    </Card>
                    <br />
                    <div style={{padding: "5px", marginTop: "10px"}}>
                        {user ? <UserForm type="controller" companyId={company.id} close={this.userClick} /> : undefined}
                        {addCreds ? <div>
                            <br />
                            {stageLoading ? <Loader /> :
                                <div>

                                    <TenantForm setTenant={this.addTeantDetails} tenantData={updateTentantDetails} />
                                    <Button onClick={this.onClickSubmitCreds} variant="success">Update Credentials</Button>
                                </div>}
                        </div> : undefined}
                    </div>
                </Card.Body>
            </Card >
        );
    }
}
export default withRouter(AdminControllerEntity);


// WEBPACK FOOTER //
// ./src/components/adminController/AdminControllerEntity.js